import { z } from "zod";

export const productionZoneCreationSchema = z.object({
  nombre: z.string().trim().min(1, "El nombre es obligatorio."),
  zonaComercial: z.any().refine(
    (value) => {
      const selected = Array.isArray(value) ? value[0] : value;
      return !!String(selected ?? "").trim();
    },
    { message: "La zona comercial es obligatoria." },
  ),
  activo: z.any().optional().nullable(),
});

export type ProductionZoneCreationForm = z.infer<
  typeof productionZoneCreationSchema
>;
